/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import { useEffect } from 'react';
import { reportClientError } from '../lib/api';

// REGLE DE GESTION V4 : une erreur JavaScript globale ou une promesse rejetee
// doit etre visible dans Administration > Logs de traitement, sans donnees sensibles.
export default function ClientErrorReporter() {
  useEffect(() => {
    const onError = (event) => {
      const err = event?.error;
      const lastApi = window.__PROJETHUB_LAST_API_ERROR__ || {};
      reportClientError({
        page: window.location.pathname,
        action: 'Erreur JavaScript globale',
        error_name: err?.name || 'Error',
        message: err?.message || event?.message || 'Erreur JavaScript',
        stack: err?.stack,
        ...lastApi,
      });
    };
    const onUnhandled = (event) => {
      const reason = event?.reason;
      const lastApi = window.__PROJETHUB_LAST_API_ERROR__ || {};
      reportClientError({
        page: window.location.pathname,
        action: 'Promesse rejetee',
        error_name: reason?.name || 'UnhandledRejection',
        message: reason?.message || String(reason || 'Promesse rejetee'),
        stack: reason?.stack,
        ...lastApi,
      });
    };
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandled);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandled);
    };
  }, []);
  return null;
}
